import Vue, { ComponentOptions } from 'vue';
import Router, { Route, RouteConfig } from 'vue-router';
import '@/styles/common.less';
import '@/common';
import { toast } from '@mx/vix';
import { bridge } from '@/common/bridge';
import { initOrange } from '@era/coverage-report';
import { monitor } from '@/common/monitor';
import { getUrlQuery } from '@/common/utils';
import App from './App.vue';
import 'vant/lib/index.css';
import 'vant/lib/icon/local.css';
import 'driver.js/dist/driver.min.css';

Vue.use(Router);

// 覆盖率修改开始 **************************
if (process.env.BUILD_ENV === 'test') {
  initOrange({ projectKey: 'pay-dcep-activity-fe', commitId: process.env.AWP_GIT_COMMIT_ID || 'commitIdTest', swimlane: process.env.SWIMLANE });
}
// 覆盖率修改结束 **************************

export default function init(
  routes: RouteConfig[],
  options?: ComponentOptions<any>
) {
  const router = new Router({
    routes
  });

  router.beforeEach((to: Route, from: Route, next: (options?: any) => void) => {
    toast.show();
    const routerPath = getUrlQuery().routerPath;
    const isCashBackHtml = window.location.href.indexOf('cashBack.html') !== -1;
    if (routerPath && to.path === '/' && isCashBackHtml) {
      next(`/${routerPath}`);
      return;
    } else {
      next();
    }
  });

  router.beforeResolve((to: Route, from: Route, next: () => void) => {
    toast.hide();
    next();
  });

  router.afterEach((to: Route, from: Route) => {
    if ((to.meta as any).title) {
      bridge.setTitle((to.meta as any).title);
    }
  });

  Vue.config.productionTip = false;

  Vue.config.errorHandler = function (err, vm, info) {
    console.log(err);
    monitor.captureMessage({
      name: err.message,
      msg: err
    }, {
      level: 'error',
      category: 'jsError'
    });
  };

  new Vue({
    ...options,
    router,
    render: (h) => h(App)
  }).$mount('#app');
}
